<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>

    <navbar :show-back-button="false"></navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container align="center" justify="center">
        <v-row v-if="numAlertedDevices > 0">
          <v-col
            class="text-center"
            style="background-color: #b94a48; color: white; padding: 10px; border-radius: 5px; cursor: pointer;"
            @click="
              $router.push({ name: 'all_devices', query: { alert_only: 1 } })
            "
          >
            <v-badge :content="numAlertedDevices" color="error" overlap>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
            <strong>
              There {{ numAlertedDevices == 1 ? "is" : "are" }}
              {{ numAlertedDevices }} device alert{{
                numAlertedDevices == 1 ? "" : "s"
              }}!
            </strong>
          </v-col>
        </v-row>
        <v-row v-for="(row, idx) in drawerRows" :key="idx">
          <v-col
            v-for="(v, k) in row"
            :key="v.title"
            align="center"
            justify="center"
          >
            <v-card
              class="pa-2 primary secondary--text text--darken-3 homeCard"
              :class="{
                unavailable: !(
                  v.availableOffline || $store.state.networkAvailable
                )
              }"
              tile
              link
              @click="
                () => {
                  if (v.action) v.action(v);
                }
              "
            >
              <v-card-title class="justify-center">
                <v-avatar class="secondary darken-3" size="76">
                  <v-avatar class="secondary lighten-1" size="70">
                    <v-icon large class="display-2">{{ v.icon }}</v-icon>
                  </v-avatar>
                </v-avatar>
              </v-card-title>
              <v-card-text class="justify-center text-center subtitle-1">{{
                v.title
              }}</v-card-text>
              <v-avatar
                v-if="v.groupIcon"
                class="secondary darken-3"
                size="44"
                style="position:absolute;top:17px;left:17px;border-bottom-left-radius:50%;border-bottom-right-radius:50%;"
              >
                <v-avatar class="secondary lighten-1" size="38">
                  <v-icon>{{ v.groupIcon }}</v-icon>
                </v-avatar>
              </v-avatar>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiEndpoints from "../mixins/api-endpoints";
import apiRequest from "../mixins/api-request";

export default {
  mixins: [apiEndpoints, apiRequest],
  data() {
    let userData = this.loadToken(); // can not access computed properties in data() so load the token manually.
    let drawerItemsFirstRow = [
      {
        title: "My Devices",
        icon: "mdi-eight-track",
        groupIcon: "mdi-account",
        availableOffline: true,
        action: () => {
          this.$router.push("my_devices");
        }
      },

      {
        title: "Multi-Device", // Trend Graph
        icon: "mdi-eight-track",
        groupIcon: "mdi-devices",
        availableOffline: true,
        action: () => {
          this.$router.push("multi_devices");
        }
      },

      {
        title: "All Devices",
        icon: "mdi-eight-track",
        groupIcon: "mdi-earth",
        availableOffline: false,
        action: () => {
          this.$router.push("all_devices");
        }
      }
    ];

    let drawerItemsSecondRow = [];

    if (userData.permissions.includes("manage_users")) {
      drawerItemsSecondRow.push({
        title: "Users",
        icon: "mdi-account",
        availableOffline: false,
        action: () => {
          this.$router.push("users");
        }
      });
    }

    if (userData.permissions.includes("create_accounts")) {
      drawerItemsSecondRow.push({
        title: "Groups",
        icon: "mdi-account-group",
        availableOffline: false,
        action: () => {
          this.$router.push("groups");
        }
      });
    }

    if (userData.permissions.includes("create_devices")) {
      drawerItemsSecondRow.push({
        title: "Device Admin",
        icon: "mdi-eight-track",
        groupIcon: "mdi-cog",
        availableOffline: false,
        action: () => {
          this.$router.push("devices");
        }
      });

      /*
      // abandoned this in favour of a Nim application used
      // in the factory to calibrate devices.

      drawerItems.push({
        title: "Calibrate",
        icon: "mdi-gauge",
        groupIcon: "mdi-cog",
        availableOffline: true,
        action: () => {
          this.$router.push("calibrate");
        }
      });
      */
    }

    let drawerRows = [drawerItemsFirstRow, drawerItemsSecondRow];

    return { drawerRows, numAlertedDevices: 0 };
  },
  created() {
    this.pollCloudServer();
  },
  watch: {
    $route: {
      handler: function() {
        this.checkAlertedDevices();
      },
      immediate: true
    }
  },
  methods: {
    showError(message) {
      this.$refs.errorBox.showError(message);
    },
    checkAlertedDevices() {
      // checks the server for alerted devices
      // called when the route changes (through a watch)
      // and every 30 minutes via pollCloudServer
      return this.apiRequest(this.apiEndpoints.devices)
        .then(r => {
          if (this.statusOk(r.status)) {
            this.numAlertedDevices = r.body.alerted_devices;
            console.log("Alerted devices: ", this.numAlertedDevices);
          }
        })
        .catch(err => console.error(err));
    },
    pollCloudServer() {
      // just polls the devices endpoint to check for alerted devices
      // (and whether we are online).
      // only re-run the polling loop whilst we are on the same route.
      if (this.$router.currentRoute.name == "home") {
        this.checkAlertedDevices().finally(() => {
          setTimeout(this.pollCloudServer, 60000 * 30);
        });
      }
    }
  }
};
</script>

<style>
.homeCard {
  width: 150px;
  height: 150px;
  margin: 20px;
}

.unavailable {
  opacity: 0.2;
  cursor: not-allowed;
}
</style>
